/**
 * Couleurs d'une satisfaction, une par cran, selon le nombre de crans sur lesquels elle se note.
 * Ce sont celles que l'éditeur applique quand l'élément n'en porte pas les siennes.
 *
 * Le mécontentement va au rouge, la satisfaction au vert. Les échelles courtes n'ont pas de milieu à
 * ménager : à quatre crans, la moitié basse s'oppose à la moitié haute, sans orange entre les deux.
 * Les onze crans, eux, vont par groupes plutôt qu'en dégradé continu — mécontents, neutres,
 * satisfaits, très satisfaits sont ce que l'analyse distingue.
 */
export const SATISFACTION_PALETTES: Record<number, string[]> = {
    4: ['#a8071a', '#f5222d', '#a0d911', '#52c41a'],
    5: ['#a8071a', '#f5222d', '#faad14', '#a0d911', '#52c41a'],
    11: [
        '#f5222d',
        '#f5222d',
        '#f5222d',
        '#f5222d',
        '#f5222d',
        '#faad14',
        '#faad14',
        '#a0d911',
        '#a0d911',
        '#52c41a',
        '#52c41a',
    ],
};
